<template>
  <div class="home">
    <common>
      <template slot="content">
        <div class="content">
          <img src="../assets/images/login-wechat.png" srcset="../assets/images/login-wechat@2x.png 2x,../assets/images/login-wechat@3x.png 3x" alt="" class="weixin" @click="toQQ">
          <img src="../assets/images/login-qq.png" srcset="../assets/images/login-qq@2x.png 2x,../assets/images/login-qq@3x.png 3x" alt="" class="qq" @click="toQQ">
          <router-link to="/loginPhone">
            <img src="../assets/images/login-phone.png" srcset="../assets/images/login-phone@2x.png 2x,../assets/images/login-phone@3x.png 3x" alt="" class="phone">
          </router-link>
        </div>
      </template>
    </common>
  </div>
</template>

<script>
import common from "./common"
export default {
  name: "login",
  components:{common},
  data(){
    return{

    }
  },
  methods:{
    toQQ(){
      let callbaclUrl = window.location.protocol+  "//" + window.location.host;
      window.location.href= callbaclUrl+'/goldenpheasant/service/txAuth?callbackUrl='+ callbaclUrl
    }
  }
}
</script>

<style scoped>
  .content{
    margin-top:4.32rem;
  }
  .phone{
    width:11.52rem;
    height:1.824rem;
  }
  .qq{
    width:11.52rem;
    height:1.824rem;
    margin-bottom:0.96rem;
  }
  .weixin{
    width:11.52rem;
    height:1.824rem;
    margin-bottom:0.96rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue